import { CPlaceholder } from './CPlaceholder.js';

const CPlaceholderPlugin = {
    install: (app) => {
        app.component(CPlaceholder.name, CPlaceholder);
    },
};

export { CPlaceholder, CPlaceholderPlugin };
//# sourceMappingURL=index.js.map
